// src/utils/auth.js
import axios from "axios";

const ADMIN_EMAILS = [
    'admin.agendamento@cataventomaster.com',
    'bruno.oliveira.participacoes@gmail.com',
    'jessica.baptista@cataventocultural.org.br',
    'erica.felix@cataventocultural.org.br',
    'pauliceia.jesus@cataventocultural.org.br',
    'octavio.martinez@cataventocultural.org.br',
    'mariana.jesus@cataventocultural.org.br',
];

export const getUserEmail = () => {
    return localStorage.getItem('userEmail');
};

export const verifyMagicLink = async (token, emailu, typeUser) => {
    try {
        const verificatok = await mecanismolinkmagico(token);
        if (verificatok !== '0') {
            localStorage.setItem('authToken', token);
            localStorage.setItem('userEmail', verificatok);
            localStorage.setItem('userType', typeUser);

            return true;
        } else {
            return false;
        }
    } catch (error) {
        console.error('Erro ao verificar o token:', error);
        return false;
    }
};

const mecanismolinkmagico = (tok) => {
    return axios.get(`https://museucatavento.org.br/sistema-agendamento/mecanismotoken3.php?tok=${tok}`)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            console.error('Erro ao enviar e-mail:', error);
            throw error; // Propagar o erro para que possa ser tratado pelo chamador
        });
};

export const isAuthenticated = () => {
    const authToken = localStorage.getItem('authToken');
    const userEmail = localStorage.getItem('userEmail');
    const userType = localStorage.getItem('userType');

    if (!authToken || !userEmail || !userType) {
        return false;
    }

    const allowedUserTypes = ["diretor_professor_responsavel", "agencia_turismo", "eurbw34r98gh"];
    if (allowedUserTypes.includes(userType)) {
        if (userType === "eurbw34r98gh") {
            return isMasterFull();
        }
        return true;
    }
    
    return false;
};

export const isMasterFull = () => {
    const userType = localStorage.getItem('userType');
    const userEmail = localStorage.getItem('userEmail');

    return userType === "eurbw34r98gh" || ADMIN_EMAILS.includes(userEmail);
};

export const logout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('userType');
};

